import React, {useState, useEffect,useRef} from "react";
import { useNavigate,useParams,useLocation } from "react-router-dom";
import { UrlPath } from "../../../config/routeConfig";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs"
import { TopBar } from "../../shared/topBar/TopBar";
import { ToastContainer, toast } from "react-toastify";
import {
    insertorupdateInvestorTracking,getAllFamilies,getPortfoliosByFamily,getInvestorStatus,getassetclassbyType,getshareclassbyType,gettrackingdetails
} from "../../../config/apiConfig";
import { sbaAxios } from "../../utils/sbaAxios";
import { AgGridReact } from 'ag-grid-react';
import { Modal } from "react-bootstrap";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { SBAComboBox, SBADropDown, SBAMultiSelect } from '../../UiComponents/SBADropDown';
import CurrencyInput from "react-currency-input-field";
import { SBDatePicker } from '../../UiComponents/SBDatePicker';
import moment from 'moment';
import { SBNotify } from "../../utils/sbNotify";
import { getCurrencyFormat } from "./InvestorTracking";
import { getcategory } from "../../../config/apiConfig";

export const ITRedeemFee = () => {
    const Level = [
        { BreadCrumb: "Investor >", Routes: `${UrlPath.Investor}`}, 
        { BreadCrumb: "Tracker >", Routes: `${UrlPath.InvestorTracking}`},
        { BreadCrumb: "Redeem - Fee", Routes: `${UrlPath.InvestorTrackingRedeemFee}`}
    ];
    const [family, setFamily] = useState([]);
    const [selectedFamily, setSelectedFamily] = useState(null);
    const [portfolio, setPortfolio] = useState([]);
    const [selectedPortfolio, setSelectedPortfolio] = useState(null);
    const [status, setStatus] = useState();
    const [selectedStatus, setSelectedStatus] = useState(null);
    
    const [existingStatus, setExistingStatus] = useState(null);
    const [asset, setAsset] = useState([]);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const [shareClass, setShareClass] = useState([]);
    const [selectedShareClass, setSelectedShareClass] = useState(null);
    const frequency = [
        {f_name:"One Time", f_id:0},
        {f_name:"Monthly", f_id:1},
        {f_name:"Quarterly", f_id:2}
    ];
    const [selectedFrequency, setSelectedFrequency] = useState({f_name:"One Time", f_id:0});
    const [amount, setAmount] = useState(null);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [note, setNote] = useState("");
    const [previewdt,setPreviewdt]=useState([]);
    const navigate = useNavigate();
    const history = useNavigate();
    const params = useParams();
    const locationData = useLocation(); 
    const groupId = locationData.state !==null? locationData.state.groupId === undefined ? null : locationData.state.groupId:null;
    const mode = locationData.state !==null? locationData.state.mode === undefined ? null : locationData.state.mode:null;
    const [investorTrackingId,setInvestorTracking]=useState(params.InvestorTrackingId);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [fileError, setFileError] = useState(null);
    const gridRef = useRef();
    const [documents,setDocuments]=useState([]);
    const activitySourceId = 2; // Activity source ID of investor
const [documentCategories, setDocumentCategories] = useState([]);
const [selectedDocumentCategory, setSelectedDocumentCategory] = useState(null);

    const getFamily = () => {
        sbaAxios({
          url: `${getAllFamilies}`,
          method: "get",
        }).then((response) => {
          setFamily(response);
        });
      };
      const getPortfoliosByFamilyId = async (Id) => {
        try {
            const list = await sbaAxios({
                url: getPortfoliosByFamily,
                params: {
                    familyId: Id
                }
            });
            setPortfolio(list);
           
        }
        catch (e) {
            setPortfolio([]);
           
        }
    };
    const getStatus = () => {
        sbaAxios({
          url: `${getInvestorStatus}`,
          method: "get",
        }).then((response) => {
            setStatus(response);
          setSelectedStatus(response[0])
        });
      };
      const getAssetsBytranstypeId = async (id,srchstring) => {
        try {
            const list =await sbaAxios({ url: `${getassetclassbyType}?portfolioId=${id}&transactionTypeId=100&searchString=${srchstring}` })
            setAsset(list);
           
        }
        catch (e) {
            setAsset([]);
           
        }
    };
    const getshareclassbyAssetId=async(Id)=>
    {
        try {
            const list =await sbaAxios({ url: `${getshareclassbyType}?portfolioId=${selectedPortfolio.EntityId}&assetId=${Id}&transactionTypeId=100` })
            setShareClass(list);
           
        }
        catch (e) {
            setShareClass([]);
           
        }
    }
    const gettrackingdetailsbyId = async() => {
        sbaAxios({
          url: `${gettrackingdetails}?investorTrackingId=${params.InvestorTrackingId}&transactionGroupId=${groupId}`,
          method: "get",
        }).then(async(response) => {
            
          const details=response;
         setSelectedFamily({"FamilyId":response.FamilyId,"FamilyName":response.FamilyName});
         setSelectedPortfolio({"EntityId":response.PortfolioId,"EntityName":response.PortfolioName});
         setSelectedStatus({ "InvestorTrackingStatusId": response.InvestorTrackingStatusId,
         "InvestorTRackingStatusName": response.InvestorTrackingStatusName});
         setExistingStatus({ "InvestorTrackingStatusId": response.InvestorTrackingStatusId,
         "InvestorTRackingStatusName": response.InvestorTrackingStatusName});

         setSelectedAsset({"AssetId":response.AssetId,"AssetName":response.AssetName});
         setSelectedShareClass({"ShareClassId":response.ShareClassId,"ShareClassName":response.ShareClassName});
        const dt = response.DetailTransactions.map((item) => ({
          ...item,
          IsAddToTracker: true,
        }));
        
         setPreviewdt(dt);
         setSelectedFiles(response.Documents.map((item,index) => {
          item.documentId = item.DocumentId;
          item.fileName = item.DocumentName;
          item.base64String = "";
          item.documentIndex=index
          return item;
      }))
      setNote(response.Notes);
      const list = await sbaAxios({
        url: `${getcategory}${activitySourceId}`,
      });

      const activitySubTypeId = response?.ActivitySubTypeId;
                setSelectedDocumentCategory(()=>{
                  const docCategory = list.find((item) => item.ActivitySubTypeId === activitySubTypeId);
                  return docCategory;
                })
      });
      };
    const assetcmbChange=(e)=>
    {
        setSelectedAsset(e.value)
        getAssetsBytranstypeId(selectedPortfolio.EntityId,e.value.AssetName);
        getshareclassbyAssetId(e.value.AssetId);
    }
    useEffect(()=>{
        document.title="Subscription Tracking";
        getFamily();
        getStatus();
        if(investorTrackingId>0)
          {
            gettrackingdetailsbyId();
          }
    },[]);
    const chkchange = (e,params) => {
        setPreviewdt((prevData) =>
        prevData.map((item) => {
          
            if (item.TransactionDate === params.data.TransactionDate) {
           
              return {
                ...item,
               IsAddToTracker:e.target.checked
              };
            }
         
          return item;
        })
      );
        
     
          };
    const CheckboxRendererMenu = (props) => {
        const isadd = props.data;
        return (
          <div className="d-flex justify-content-start align-items-center h-100" style={{ paddingLeft: '10px' }}>
    
    
            <input type='checkbox' disabled={params.InvestorTrackingId>0} checked={params.InvestorTrackingId==0?isadd.IsAddToTracker:true} onChange={(e) => { chkchange(e, props) }} />
    
    
          </div>
        );
      };
    const FormatCurrencyGrid = (params) => {

        var num = params.value;
    
        if (num !== undefined) {
          // Check if the value is negative
          const isNegative = num < 0;
    
          // Remove negative sign and format with parentheses
          const formattedValue =getCurrencyFormat(num); 
          
          
          // isNegative
          //   ? `($${Math.abs(num).toLocaleString('en-US', {
          //     minimumFractionDigits: 0,
          //     maximumFractionDigits: 0
          //   })})`
          //   : `$${num.toLocaleString('en-US', {
          //     minimumFractionDigits: 0,
          //     maximumFractionDigits: 0
          //   })}`;
    
          // Apply red color for negative values
          const style = isNegative ? { color: 'red' } : null;
    
          return <span style={style}>{formattedValue}</span>;
        } else {
          return num;
        }
      };

      const getFormattedDate=(params)=>{
        return params.value ? moment(params.value).format("MM-DD-YYYY") : "";
      };
      const currentamtChange=(params)=>
      {
        setPreviewdt((prevData) =>
        prevData.map((item) => {
          
            if (item.TransactionDate === params.data.TransactionDate) {
           
              return {
                ...item,
               TransactionAmount: params.newValue
              };
            }
         
          return item;
        })
      );
      }
    const colDefs = [
        {headerName: 'Transaction Date', field:"TransactionDate",editable: existingStatus?.InvestorTrackingStatusId!=9, valueFormatter: getFormattedDate ,  cellEditor: "agDateStringCellEditor"},
        {headerName: 'Amount', field: "TransactionAmount" ,editable:true,cellStyle: { textAlign:"right"},cellRenderer:FormatCurrencyGrid, onCellValueChanged: (params) => { currentamtChange(params) }},
        {headerName:'Add to Tracker', field:'IsAddToTracker', cellRenderer: CheckboxRendererMenu}
    ]

    const familycmbChange=(e)=>
    {
        if(e.value)
        {
            setSelectedFamily(e.value);
            setSelectedAsset(null);
            setSelectedPortfolio(null);
            setSelectedShareClass(null);
            setAsset(val=>[]);
            setShareClass(val=>[]);
        }
        
        getPortfoliosByFamilyId(e.value.FamilyId);
    }
    const AssetFilterChange = (e) => {
        const terms = e.filter.value;
        if (terms.length > 1) {
          getAssetsBytranstypeId(selectedPortfolio.EntityId,terms);
        }
      };

      const fetchDocumentCategories = async () => {
        try {
          const list = await sbaAxios({
            url: `${getcategory}${activitySourceId}`,
          });
          setDocumentCategories(list);
        } catch (e) {
          setDocumentCategories([]);
        }
      };
      useEffect(() => {
        fetchDocumentCategories();
      }, []);
      
   const addFrequencyData=()=>
   {
    const quarterlyDates =[];
    if (selectedFrequency?.f_id === 2)
    {
        quarterlyDates.push(...getQuarterDate(startDate,endDate));
    }
    else
    {
        quarterlyDates.push(...getMonthlydate(startDate,endDate));
    }
    const previewData = [];
   if(!amount||amount===0)
   {
    SBNotify({ Msg: "Please Enter Amount", type: "error" })
    return;
   }
   else{
    quarterlyDates.forEach(date => {
        previewData.push({
            TransactionDate: date.toISOString(), 
            TransactionAmount: amount, 
            IsAddToTracker: false
        });
    });
}
   setPreviewdt(previewData); 
   }
   const getQuarterDate = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);

    let current = new Date(start);
    const quarterlyDates = [];

    while (current <= end) {
        const year = current.getFullYear();
        const quarter = Math.floor((current.getMonth() + 3) / 3);
        const lastMonthOfQuarter = quarter * 3;
        const lastDate = new Date(year, lastMonthOfQuarter, 0); // 0th day of the next month
        if (lastDate >= start && lastDate <= end) {
            quarterlyDates.push(lastDate);
        }
        const nextQuarterMonth = (quarter * 3) % 12;
        current = new Date(year, nextQuarterMonth, 1);
        if (nextQuarterMonth === 0) {
            current.setFullYear(year + 1); // Move to the next year
        }
    }
    return quarterlyDates;
};

const getMonthlydate = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);

    let current = new Date(start);
    const monthlyDates = [];

    while (current <= end) {
        const year = current.getFullYear();
        const month = current.getMonth();
        const lastDateOfMonth = new Date(year, month + 1, 0); 
        if (lastDateOfMonth >= start && lastDateOfMonth <= end) {
            monthlyDates.push(lastDateOfMonth);
        }
        current.setMonth(current.getMonth() + 1);
    }

    return monthlyDates;
};
 const saveoreditinvestorTracking=()=>
 {
    let saveSuccess=true;
     if (!selectedFamily) {
        SBNotify({ Msg: "Please Select Family", type: "error" });
        saveSuccess = false;
        return;
      }
     else if (!selectedPortfolio) {
        SBNotify({ Msg: "Please Select Portfolio", type: "error" });
        saveSuccess = false;
        return;
      }
     else if (!selectedAsset) {
        SBNotify({ Msg: "Please Select Asset", type: "error" });
        saveSuccess = false;
        return
      }
     else if (!selectedStatus) {
        SBNotify({ Msg: "Please Select Status", type: "error" });
        saveSuccess = false;
        return;
      }
     else if (!selectedShareClass) {
        SBNotify({ Msg: "Please Select ShareClass", type: "error" });
        saveSuccess = false;
        return;
      }
     
      const selecteditems = previewdt.filter(item => item.IsAddToTracker);  
     
   if(selecteditems.length===0)
  {
   SBNotify({ Msg: "Please select AddToTracker", type: "error" });
   saveSuccess = false;
   return;
  }

  if (selecteditems.some(item => !item.TransactionDate)) {
    SBNotify({ Msg: "Please Select the Transaction Date", type: "error" });
    saveSuccess = false;
    return;
  }

  if (selectedFiles.length > 0 && !selectedDocumentCategory?.ActivitySubTypeId) {
    SBNotify({ Msg: "Please Select the Document Category", type: "error" });
    saveSuccess = false;
    return;
  }
  


     const data =
        selecteditems.map((item) => {
             return {
              ActivityId:0,
                 InvestorTrackingId: params.InvestorTrackingId==0?0:item.InvestorTrackingId,
                 TransactionDate: item.TransactionDate,
                 FamilyId: selectedFamily.FamilyId,
                 PortfolioId: selectedPortfolio.EntityId,
                 AssetId: selectedAsset.AssetId,
                 ShareClassId: selectedShareClass.ShareClassId,
                 AssetLotId: 0,
                 InvestorTrackerStatusId: selectedStatus.InvestorTrackingStatusId,
                 TransactionTypeId: 100,
                 TransactionGroupId: params.InvestorTrackingId==0?0:groupId,
                 TransactionAmount: item.TransactionAmount,
                 TransactionPercentage: 0,
                 Notes: note
             };
         });
         const DocumentItems=selectedFiles.map(item=>(
          {
              "documentId": item.documentId,
              "documentName": item.fileName,
              "documentContent": item?.base64String ||"",
                 "documentExtension": "pdf"
          }
      ))
         const dto={
          Transactions: data,
          Documents:DocumentItems,
          ActvitySubTypeId: selectedFiles.length === 0 ? 0 : selectedDocumentCategory.ActivitySubTypeId

         }
        if(saveSuccess)
        {
       
         //setLoading(true);
      sbaAxios({
        url: `${insertorupdateInvestorTracking}`,
        method: 'post',
        data: dto,
      })
        .then(() => {
          toast.success("Investor Tracking Save Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
        
            //setLoading(false);
            history(`${UrlPath.InvestorTracking}`);
  
          
        }).catch(() => {
          toast.error("Error updating Investor Tracking", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
         // setLoading(false);
        });
       
 }
}
const gridValueFormatter = (params) => {
    return params.value;
};
const allowedExtensions = ['pdf'];
    const handleFileChange = (event) => {
        const newFiles = event.target.files;
        if (newFiles.length > 0) {
          const updatedFiles = [...selectedFiles];
          const startingRowIndex = updatedFiles.length; 
        
          for (let i = 0; i < newFiles.length; i++) {
            const file = newFiles[i];
            const fileName = file.name;
            const lastDotIndex = fileName.lastIndexOf('.');
            const extension = lastDotIndex >= 0 ? fileName.substring(lastDotIndex + 1) : '';
            // Check if the extension is allowed
            if (!allowedExtensions.includes(extension.toLowerCase())) {
                setFileError(`Unsupported file format: .${extension}`);
                continue; // Skip the rest if the format is invalid
            }
            setFileError("");
            const reader = new FileReader();
            reader.onload = function () {
              if (reader.result) {
                const arrayBuffer = reader.result;
                const base64String = arrayBufferToBase64(arrayBuffer);
                const rowIndex = startingRowIndex + i;        
                updatedFiles.push({ file, fileName, extension, base64String, documentId:0 ,rowIndex ,documentIndex:selectedFiles.length});
                setSelectedFiles(updatedFiles);
                
                
                
              }
            };
        
            reader.readAsArrayBuffer(file);
          }
        }
        
    };

    const arrayBufferToBase64 = (arrayBuffer) => {
        const binary = [];
        const bytes = new Uint8Array(arrayBuffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary.push(String.fromCharCode(bytes[i]));
        }
        return btoa(binary.join(''));
    };

    const onCellValueChanged = (params) => {
        const updatedDocuments = selectedFiles.map(doc =>
            doc.id === params.data.id ? { ...doc, DocumentName: params.data.DocumentName } : doc
        );
        setSelectedFiles(updatedDocuments);
    };

    const DeleteButtonRenderer = (props) => {
        const handleDeleteClick = () => {
          const updatedFiles = selectedFiles.filter((item, index) => item.documentIndex !== props.data.documentIndex);
            setSelectedFiles(updatedFiles);
        }
        return (
            <div className="actions-cell">
                <i
                    className="fas fa-trash"
                    style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
                    onClick={handleDeleteClick}
                ></i>
            </div>
        );
    };
   
const fileColDefs = [
    {
        field: "fileName",
        headerName: "File Name",
        //cellRenderer: HyperlinkRenderer,
        sort: "asc",
        pinned: "left",
        minWidth: 442.47,
        floatingFilter: false,
        valueFormatter: gridValueFormatter,
        tooltipField: 'FileName',
        editable: true,
    },
    {
        headerName: "",
        field: "Delete",
        floatingFilter: false,
        minWidth: 442.47,
        cellRenderer: DeleteButtonRenderer,
    }
];
const defaultColDef = {
    sortable: true, filter: true, floatingFilter: true, flex: 1, resizable: true,
}

  const amtchange=(value)=>
{
  if (selectedFrequency?.f_id == 0)
    {
  setPreviewdt(
    [
     {
       IsAddToTracker:true,
       TransactionAmount: value, 
       TransactionDate: moment(startDate).format("MM-DD-YYYY"), 
     }
    ]);
  }
   setAmount(value);
 
}


const dateonChange=(val)=>
{
  if (selectedFrequency?.f_id == 0)
  {
  setPreviewdt(
    [
     {
       IsAddToTracker:true,
       TransactionAmount: amount, 
       TransactionDate:  moment(val).format("MM-DD-YYYY"), 
     }
    ]);
  }
  setStartDate(val);
}

const frequencyOnChange =(e)=>
{
setSelectedFrequency(e.value);
setPreviewdt([]);
setStartDate(new Date())
}
return(
        <>
        <TopBar label={"Investor Tracking - Redeem - Fee"} />
        <div className="mainContentData">
            <BreadCrumbs Levels={Level} />
            <div className="container-fluid p-4">
                <div className="row">
                    <div className="detail p-4">
                    <div className="row border-bottom pb-3">
                            <div className="col-4">
                                <label className="label"> Family<span className="mandatory">*</span></label>
                                <div>
                                    <SBAComboBox
                                        className="w-100"
                                        data={family}
                                        textField={"FamilyName"}
                                         valueField={"FamilyId"}
                                        value={selectedFamily}
                                        onChange={familycmbChange}
                                        popupSettings={{ className: "modalDD" }}
                                        disabled={investorTrackingId>0?true:false}
                                    ></SBAComboBox>
                                </div>
                            </div>
                            <div className="col-4">
                            <label className="label">Portfolio<span className="mandatory">*</span></label>
                                <div>
                                    <SBAComboBox
                                        className="w-100"
                                        data={portfolio}
                                       textField={"EntityName"}
                                        valueField={"EntityId"}
                                        value={selectedPortfolio}
                                        onChange={(e) => {
                                            setSelectedPortfolio(e.value);
                                            setSelectedAsset([]);
                                        }}
                                        popupSettings={{ className: "modalDD" }}
                                        disabled={investorTrackingId>0?true:false}
                                    ></SBAComboBox>
                                </div>
                            </div>
                            <div className="col-4">
                            <label className="label">Status<span className="mandatory">*</span></label>
                                <div>
                                    <SBAComboBox
                                        className="w-100"
                                        data={status}
                                       textField={"InvestorTRackingStatusName"}
                                       valueField={"InvestorTrackingStatusId"}
                                    value={selectedStatus}
                                        onChange={(e) => setSelectedStatus(e.value)}
                                        popupSettings={{ className: "modalDD" }}
                                       // disabled={investorTrackingId>0?true:false}
                                    ></SBAComboBox>
                                </div>
                            </div>
                            <div className="col-4">
                            <label className="label">Asset<span className="mandatory">*</span></label>
                                <div>
                                    <SBAComboBox
                                        className="w-100"
                                        data={asset}
                                      textField={"AssetName"}
                                        valueField={"AssetId"}
                                        value={selectedAsset}
                                        onChange={assetcmbChange}
                                        onFilterChange={AssetFilterChange}
                                        popupSettings={{ className: "modalDD" }}
                                        disabled={investorTrackingId>0?true:false}
                                    ></SBAComboBox>
                                </div>
                            </div>
                            <div className="col-4">
                            <label className="label">Share Class<span className="mandatory">*</span></label>
                                <div>
                                    <SBAComboBox
                                        className="w-100"
                                        data={shareClass}
                                        textField={"ShareClassName"}
                                       valueField={"ShareClassId"}
                                        value={selectedShareClass}
                                        onChange={(e) => setSelectedShareClass(e.value)}
                                        popupSettings={{ className: "modalDD" }}
                                        disabled={investorTrackingId>0?true:false}
                                    ></SBAComboBox>
                                </div>
                            </div>
                        </div>
                 

                        {params.InvestorTrackingId == 0 ? (<>
                            <div className="row">
                                <label className="mb-1 label">Add Transaction</label>
                                <div className="row mt-2">
                                    {/* Frequency Dropdown */}
                                    <div className="col-2">
                                        <label className="label">Frequency</label>
                                        <div>
                                            <SBAComboBox
                                                className="w-100"
                                                data={frequency}
                                                textField="f_name"
                                                valueField="f_id"
                                                value={selectedFrequency}
                                                onChange={(e) => {frequencyOnChange(e)}}
                                                popupSettings={{ className: "modalDD" }}
                                            />
                                        </div>
                                    </div>

                                    {/* Amount Input */}
                                    <div className="col-2">
                                        <label className="label">
                                            Amount<span className="mandatory">*</span>
                                        </label>
                                        <CurrencyInput
                                            name="commitment"
                                            className="w-100 input-default form-control text-right no-arrows"
                                            value={amount}
                                            decimalsLimit={2} // Limit to two decimal places
                                            onValueChange={(value) => {amtchange(value || "0")}}
                                            prefix="$" // Add a dollar sign as a prefix
                                            onFocus={(event) => event.target.select()}
                                        />
                                    </div>

                                    {/* Start Date Input */}
                                    <div className="col-2">
                                        <label className="label">
                                            {selectedFrequency?.f_id === 0 ? "Date" : "Start Date"}
                                        </label>
                                        <div>
                                            <SBDatePicker
                                                className="w-100"
                                                value={moment(startDate)}
                                                onChange={(newDate) =>{dateonChange(newDate)} }
                                            />
                                        </div>
                                    </div>

                                    {/* End Date Input (conditional) */}
                                    {selectedFrequency?.f_id !== 0 && (
                                        <div className="col-2">
                                            <label className="label">End Date</label>
                                            <SBDatePicker
                                                className="w-100"
                                                value={moment(endDate)}
                                                onChange={(newDate) => setEndDate(newDate)}
                                            />
                                        </div>
                                    )}
                                </div>

                                {/* Add to Preview Button (conditional) */}
                                <div className="row border-bottom pb-3">
                                    {selectedFrequency?.f_id !== 0 && (
                                        <div className="col-12 d-flex justify-content-end mt-3">
                                            <button
                                                type="submit"
                                                className="p-sm-btn"
                                                onClick={addFrequencyData}
                                            >
                                                Add to Preview
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </>) : (
                            <></>
)}

                            <>
  {params.InvestorTrackingId == 0 ? (
    selectedFrequency?.f_id == 0 ? (
      <div className="row mt-2">
        <div className="col-4">
          <label className="mb-1 label">Notes</label>
          <div>
            <textarea
              className="form-control"
              type="text"
              name="note"
              onChange={(e) => setNote(e.target.value)}
              defaultValue={note}
              style={{ height: "200px" }}
            />
          </div>
        </div>
      </div>
    ) : (
      <div className="row mt-2 d-flex">
        <div className="col-6">
          <label className="mb-1 label">Preview</label>
          <div className="ag-theme-alpine" style={{ height: "300px", paddingTop: 0 }}>
            <AgGridReact
                                                        rowData={previewdt}
              columnDefs={colDefs}
              defaultColDef={{ resizable: true, sortable: true, filter: true, flex: 1 }}
              rowSelection="single"
            />
          </div>
        </div>
        <div className="col-6">
          <label className="mb-1 label">Notes</label>
          <div>
            <textarea
              className="form-control"
              type="text"
              name="note"
              onChange={(e) => setNote(e.target.value)}
              defaultValue={note}
              style={{ height: "300px" }}
            />
          </div>
        </div>
      </div>
    )
  ) : (
    <div className="row mt-2 d-flex">
      <div className="col-6">
        <label className="mb-1 label">Preview</label>
        <div className="ag-theme-alpine" style={{ height: "300px", paddingTop: 0 }}>
          <AgGridReact
                                                    rowData={previewdt}
            columnDefs={colDefs}
            defaultColDef={{ resizable: true, sortable: true, filter: true, flex: 1 }}
            rowSelection="single"
          />
        </div>
      </div>
      <div className="col-6">
        <label className="mb-1 label">Notes</label>
        <div>
          <textarea
            className="form-control"
            type="text"
            name="note"
            onChange={(e) => setNote(e.target.value)}
            defaultValue={note}
            style={{ height: "300px" }}
          />
        </div>
      </div>
    </div>
  )}
</>
<div className="col-6">
                        <div className="row">
                        <label className="mb-1 label">Upload Files : (PDF Only)</label>
                            <div className="mt-2" style={{ position: "relative" }}>
                                <input
                                    type="file"
                                    id="fileInput"
                                    className="input-hidden"
                                    onChange={handleFileChange}
                                />
                                {fileError && <p style={{ color: 'red' }}>{fileError}</p>}
                            </div>
                        </div>

                        <div className="row mt-2">
  <label className="label">Document Category<span className="mandatory">*</span></label>
  <div>
    <SBAComboBox
      className="w-50"
      data={documentCategories}
      textField={"ActivitySubType"}
      valueField={"ActivitySubTypeId"}
      value={selectedDocumentCategory}
      onChange={(e) => setSelectedDocumentCategory(e.value)}
      popupSettings={{ className: "modalDD" }}
      disabled={selectedFiles.length === 0}
    />
  </div>
</div>

                        <div className="row mt-2">
                            <div className="ag-theme-alpine" style={{ width: '100%', height: '300px' }}>
                                <AgGridReact
                                    columnDefs={fileColDefs}
                                    rowData={selectedFiles}
                                    defaultColDef={defaultColDef}
                                    // domLayout= {'autoHeight'}
                                    onCellValueChanged={onCellValueChanged}
                                    overlayNoRowsTemplate={`<span>${'No data Available'}</span>`}
                                    ref={gridRef}
                                >
                                </AgGridReact>
                            </div>
                        </div>
                    </div>
                </div>
              
                </div>
                <div className="d-flex justify-content-end gap-2 mt-3">
                    <button className="s-sm-btn me-1" onClick={()=>{navigate(UrlPath.InvestorTracking)}}>
                        Cancel
                    </button>
                    <button className="p-sm-btn mx-1" onClick={saveoreditinvestorTracking} 
disabled={existingStatus?.InvestorTrackingStatusId==9}>
                       {mode === "Edit" ? "Update" : "Add To Tracker"}
                    </button>
                </div>
            </div>
        </div>
        <ToastContainer/>
        </>
    );
}